export async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function formatTime(seconds) {
    if (!seconds) {
        return "00:00";
    }

    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    const formattedHrs = hrs > 0 ? String(hrs).padStart(2, "0") + ":" : "00:";
    const formattedMins = String(mins).padStart(2, "0") + ":";
    const formattedSecs = String(secs).padStart(2, "0");

    if (formattedHrs === "00:") {
        return formattedMins + formattedSecs;
    }

    return formattedHrs + formattedMins + formattedSecs;
}
